import { AutocompleteInput } from "@/components/admin";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Briefcase } from "lucide-react";
import {
  Edit,
  NumberInput,
  ReferenceInput,
  SimpleForm,
  TextInput,
} from "../common";

export const DesignationEdit = () => (
  <Edit title="Edit Designation" actions={false}>
    <SimpleForm className="max-w-3xl mx-auto space-y-6">
      <Card className="w-full shadow-sm">
        <CardHeader className="pb-3 border-b bg-muted/50">
          <div className="flex items-center gap-2">
            <Briefcase className="w-5 h-5 text-muted-foreground" />
            <CardTitle className="text-lg font-semibold tracking-tight">Edit Designation Details</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <TextInput source="title" label="Designation Title" />
            <NumberInput source="level" label="Hierarchical Level" />
            <ReferenceInput source="department_id" reference="hr_departments">
              <AutocompleteInput label="Department" optionText="name" />
            </ReferenceInput>
          </div>
        </CardContent>
      </Card>
    </SimpleForm>
  </Edit>
);
